import module from 'nominas/nomina/module.js'

export const schema = {
  Suministro: 'number',
  Suministro_Calculado: 'number',
  Fecha: 'date',
  Fecha_Inicial: 'date',
  Fecha_Final: 'date',
  Fecha_Pago: 'date',
  Carga_Social: 'number',
  Comision_Porcentaje_SA: 'number',
  Comision_Importe_SA: 'number',
  Subtotal_SA: 'number',
  IVA_SA: 'number',
  Total_SA: 'number',
  Tipo_Cambio: 'number',
  tipo_cambio_fecha: 'date',
  Contiene_Informacion: 'boolean',
  Carga_Social_No_Remunerados: 'number',
  impuesto_estatal: 'number',
  otros: 'number',
  Subtotal_No_Remunerados: 'number',
  IVA_No_Remunerados: 'number',
  Total_No_Remunerados: 'number',
  status_calculado: 'boolean',
  status_maquilado: 'boolean',
  status_acumulado: 'boolean',
  status_cotizado: 'boolean',
  status_aprobado: 'boolean',
  status_pagado: 'boolean',
  status_timbrado: 'boolean',
  Acumulado_Fecha: 'datetime',
  Calculo_Fecha: 'datetime',
  pueblo_bonito: 'boolean',
  prorrateo: {
    id: 'number',
    porcentaje: 'number',
  },
}

export class NominasNominaService {
  constructor ($http) {
    this.$http = $http
  }

  get (idProyecto, idNomina) {
    return this.$http.get('/kendu/nominas/nomina', {
        params: {idEmpresa: idProyecto, idNomina: idNomina},
        schema,
        cache: 'nominas',
      })
      .then(({data}) => data)
  }

  delete (idProyecto, idNomina) {
    return this.$http.delete('/api/nominas/nomina', {
      params: {id_proyecto: idProyecto, id_nomina: idNomina},
      clearCache: 'nominas',
    })
  }

  cerrarNomina (idProyecto, idNomina, deducciones) {
    return this.$http.put('/kendu/nominas/nomina/cerrar', deducciones, {
      params: {idEmpresa: idProyecto, idNomina: idNomina},
      clearCache: 'nominas',
    })
  }

  calculado (idProyecto, idNomina) {
    return this.$http.put('/api/nominas/nomina/status/calculado', null, {
      params: {idEmpresa: idProyecto, idNomina: idNomina},
      schema,
      clearCache: 'nominas',
    })
  }
}

module.service('NominasNomina', NominasNominaService)



// WEBPACK FOOTER //
// ./src/nominas/nomina/services/Nomina.js